import { ConfirmActionModal } from '@/components/commons/confirm-action-modal'
import { useUpdateStepToRetouchingQa } from '@/features/photoset/queries/use-update-step-to-retouching-qa'
import type { Photoset } from '@/features/photoset/types'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS, queryClient } from '@/query-client'
import { useTranslation } from '@/translations/i18n'

export const VettingQaConfirmationModal = ({
	photosetId,
	onClose
}: {
	photosetId: Photoset['id']
	onClose: () => void
}) => {
	const { t } = useTranslation()

	const updateStepToAiManualRetouchingMutation = useUpdateStepToRetouchingQa({
		onError: (error) => errorHandler(error),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.PHOTOSET]
			})
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.PHOTOSET_SPACES]
			})
		}
	})

	return (
		<ConfirmActionModal
			headerTitle=''
			isLoading={updateStepToAiManualRetouchingMutation.isPending}
			onClose={onClose}
			onConfirm={() =>
				updateStepToAiManualRetouchingMutation.mutate(photosetId)
			}
			paragraph={t('photoset:vetting_qa.confirmation_modal_paragraph')}
			title={t('photoset:vetting_qa.confirmation_modal_title')}
		/>
	)
}
